module.exports = __webpack_public_path__ + "img/ball_1_transparent.d9443e5e.png";